"use strict";

// observer.js
(() => {
  const initObserver = () => {
    // JS が動いたときだけ初期状態（透明）を有効にする
    document.documentElement.classList.add("js-observer");

    // 汎用アニメーション
    const selectors = [".u-animation--fadeIn", ".u-animation--appear", ".u-animation--scale"];

    const targets = document.querySelectorAll(selectors.join(", "));
    if (!targets.length) return;

    if (!("IntersectionObserver" in window)) {
      targets.forEach((el) => el.classList.add("js-show"));
      return;
    }

    const onEnter = (entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("js-show");
        obs.unobserve(entry.target);
      });
    };

    const observer = new IntersectionObserver(onEnter, {
      root: null,
      rootMargin: "0px",
      threshold: 0.2, // 20%表示で発火
    });

    // 画面より高い要素は 20% が一度に見えないので、入った時点で発火させる
    const tallObserver = new IntersectionObserver(onEnter, {
      root: null,
      rootMargin: "0px 0px -80px 0px",
      threshold: 0,
    });

    targets.forEach((el) => {
      const isTall = el.getBoundingClientRect().height > window.innerHeight * 0.5;
      (isTall ? tallObserver : observer).observe(el);
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initObserver, { once: true });
  } else {
    initObserver();
  }
})();
